import type { OfferedProjectType } from "../../../../clients/graphqlTypes.js";

// MEIS-11839: project-type set surfaced by the offered-services UI flows
// (onboarding tile grid, specify-matrix columns, settings checkboxes).
// Excludes OTHER, whose semantic ("this org offers OTHER for that category")
// is implicit in the presence of an organisation_categories row.
export const OFFERED_PROJECT_TYPES: OfferedProjectType[] = [
  "NEW",
  "REPAIR",
  "RENOVATION",
  "MAINTENANCE",
  "DIY",
];

// MEIS-12682: activating a category auto-fills its leaves' actions, but DIY
// ("do it yourself") is deliberately excluded — it stays opt-in and must be
// ticked manually. The ticket's auto-fill set is new/repair/renovation/
// maintenance only.
export const AUTO_FILLED_PROJECT_TYPES: OfferedProjectType[] =
  OFFERED_PROJECT_TYPES.filter(pt => pt !== "DIY");
